import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  viewBox: "0 0 16 16"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("g", {
      fill: "none",
      "fill-rule": "evenodd"
    }, [
      _createElementVNode("g", null, [
        _createElementVNode("g", null, [
          _createElementVNode("g", null, [
            _createElementVNode("g", null, [
              _createElementVNode("path", {
                fill: "#A7A7A9",
                d: "M9.428 2.761c3.682 0 6.667 2.985 6.667 6.667s-2.985 6.667-6.667 6.667-6.667-2.985-6.667-6.667 2.985-6.667 6.667-6.667zm0 1c-3.13 0-5.667 2.537-5.667 5.667s2.537 5.667 5.667 5.667 5.667-2.537 5.667-5.667-2.537-5.667-5.667-5.667zm0 1.834c.253 0 .462.188.496.432l.004.068v2.832l2.833.001c.277 0 .5.224.5.5 0 .253-.188.462-.432.496l-.068.004H9.927l.001 2.833c0 .277-.224.5-.5.5-.253 0-.462-.188-.495-.432l-.005-.068V9.927l-2.833.001c-.276 0-.5-.224-.5-.5 0-.253.188-.462.432-.495l.068-.005h2.832l.001-2.833c0-.276.224-.5.5-.5z",
                transform: "translate(-898 -24) translate(574 10) translate(320 10) translate(2.572 2.572) rotate(45 9.428 9.428)"
              })
            ])
          ])
        ])
      ])
    ], -1)
  ]))]))
}
export default { render: render }